import { z } from 'zod';
import { TokenTypeKey } from './token-setting.model';

export const InsufficientTokenBudgetErrorSchema = z.object({
  detail: z.string(),
  token_type: z.enum(TokenTypeKey),
  on_demand_available: z.boolean(),
  on_demand_enabled: z.boolean(),
  on_demand_budget_exhausted: z.boolean(),
});

export type InsufficientTokenBudgetError = z.infer<
  typeof InsufficientTokenBudgetErrorSchema
>;
